import { ReactNode, useEffect, useState } from 'react';

import { Navigate } from 'react-router-dom';

import {
  RECORDING_ANNOUNCEMENT_REDIRECT_STATE,
  useRecordingAnnouncementRedirect,
} from '@/features/recordingAnnouncement';

import { PATHS } from '@/shared/constants/routes/paths';
import { Loader } from '@/shared/ui/Loader';

type SpaceIndexRouteProps = {
  children: ReactNode;
};

export const SpaceIndexRoute = ({ children }: SpaceIndexRouteProps) => {
  const announcement = useRecordingAnnouncementRedirect();
  const { markRedirected: markAnnouncementRedirected } = announcement;
  const [showAnnouncement, setShowAnnouncement] = useState<boolean | null>(null);

  if (announcement.status === 'resolved' && showAnnouncement === null) {
    setShowAnnouncement(announcement.shouldRedirect);
  }

  useEffect(() => {
    if (showAnnouncement) markAnnouncementRedirected();
  }, [showAnnouncement, markAnnouncementRedirected]);

  if (showAnnouncement === null) return <Loader />;

  if (showAnnouncement) {
    return <Navigate state={RECORDING_ANNOUNCEMENT_REDIRECT_STATE} to={PATHS.translation} replace />;
  }

  return children;
};
